import React, { useState, useMemo,useEffect } from "react";
import * as XLSX from "xlsx";
import { Progress } from "reactstrap";
import Table from '../../../components/UI/Table/Table'

const FileUpload = ({
  onFileSelect,
  uploadProgress,
  previewData,
  setPreviewData,
  setError,
  conditionalColumnConfig,
}) => {
  const [dragActive, setDragActive] = useState(false);
  const [pageSize, setPageSize] = useState(10);
const [page, setPage] = useState(0);
useEffect(() => {
  setPage(0);
}, [previewData,pageSize]);
  const handleFile = (file) => {
    if (!file || !file.name.endsWith(".xlsx")) {
      setError("Only .xlsx files allowed");
      return;
    }
    

    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];

      const sheetData = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: ""
      });

      if (!sheetData || sheetData.length < 2) {
        setPreviewData(null);
        return;
      }

      const noteRow = sheetData[0];         
      const headers = sheetData[1];
      const dataRows = sheetData.slice(2);

      const formattedRows = dataRows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          if (header && !header.toLowerCase().startsWith("__empty")) {
            obj[header] = row[index] || "";
          }
        });
        return obj;
      });

      setPreviewData({
        note: noteRow,
        headers,
        rows: formattedRows
      });

      onFileSelect(file);
    };

    reader.readAsArrayBuffer(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragActive(false);
    handleFile(e.dataTransfer.files[0]);
  };

  // =============================
  // Conditional Column Logic
  // =============================
  const shouldShowDependentColumn =
    conditionalColumnConfig &&
    previewData?.rows?.some(
      (row) =>
        row[conditionalColumnConfig.triggerColumn] ===
        conditionalColumnConfig.triggerValue
    );

  // =============================
  // Dynamic Columns
  // =============================
  const columns = useMemo(() => {
    if (!previewData?.headers) return [];

    return previewData.headers
      .filter((header) => {
        if (!header) return false;

        if (
          conditionalColumnConfig &&
          header === conditionalColumnConfig.dependentColumn &&
          !shouldShowDependentColumn
        ) {
          return false;
        }

        return !header.toLowerCase().startsWith("__empty");
      })
      .map((header) => ({
        Header: header,
        accessor: header,
        className: "center",
      }));
  }, [previewData, conditionalColumnConfig, shouldShowDependentColumn]);

  return (
    <div
      className={`border rounded p-4 text-center ${
        dragActive ? "bg-light border-primary" : ""
      }`}
      onDragOver={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragLeave={() => setDragActive(false)}
      onDrop={handleDrop}
    >
      <p>Drag & Drop Excel file here or click to upload</p>

      <input
        type="file"
        accept=".xlsx"
        onChange={(e) => handleFile(e.target.files[0])}
      />

      {uploadProgress > 0 && (
        <Progress value={uploadProgress} className="mt-3">
          {uploadProgress}%
        </Progress>
      )}

      {previewData?.rows?.length > 0 && (
        <div className="mt-4 text-left">
          <h6>Preview</h6>

          {/* Show NOTE row exactly like Excel */}
          <div
            style={{
              backgroundColor: "#fff3cd",
              padding: "10px",
              fontWeight: "500",
              marginBottom: "10px",
            }}
          >
            {previewData.note?.join(" ")}
          </div>

          {/* Show Table */}
          <Table
            data={previewData.rows}
            columns={columns}
            manual={false}
              page={page}

            pageSize={pageSize}
              onPageChange={(p) => setPage(p)}

      onPageSizeChange={(size) => setPageSize(size)}

          />
        </div>
      )}
    </div>
  );
};

export default FileUpload;